import React from 'react';
import './EmptyState.scss';

export interface EmptyStateProps {
  /**
   * Type of empty state:
   * - "filter": Active filters produced no matches.
   * - "search": No results for the current search term.
   * - "folder": Folder has no content.
   */
  type?: 'search' | 'folder' | 'filter';
}

/**
 * Empty state message renderer for both list and tile views.
 * Used when a folder is empty or when a search/filter returns no results.
 * Presentational only — parent handles conditional rendering logic.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ type = 'search' }) => {
  const message =
    type === 'filter'
      ? 'No files or folders match the selected filters.'
      : type === 'search'
        ? 'No matching files or folders found.'
        : 'This folder is empty.';

  return <div className="empty-state">{message}</div>;
};
